// Product catalog for Quantum Genesis Labs
// All peptides are for research purposes only.

const VIAL = (slug) => `/vials/${slug}.png`;

export const VIAL_IMAGE = "https://static.prod-images.emergentagent.com/jobs/b641045e-a9d3-4d1c-90bd-c8d1bc62c5e2/images/5186c857c91a1448c457af54f8815bda789db92d840b4dedd7a701fa0e930bfd.png";
export const HERO_IMAGE = "https://static.prod-images.emergentagent.com/jobs/b641045e-a9d3-4d1c-90bd-c8d1bc62c5e2/images/68c50ca7c2bc6b8a1dc28b6c86ce57118e51d1f7098d1fb75e6e66eb74fbd7e4.png";
export const LAB_ABSTRACT = "https://static.prod-images.emergentagent.com/jobs/b641045e-a9d3-4d1c-90bd-c8d1bc62c5e2/images/f2e1154220d9aba06a5a480e6ff4ebaf67fe34d50f8f9e173e5f2a08d98586a0.png";
export const SCIENCE_ABSTRACT = "https://static.prod-images.emergentagent.com/jobs/b641045e-a9d3-4d1c-90bd-c8d1bc62c5e2/images/84d5d0e143b9658d77ea849aee281a77b5ac6424a656e75de49580f2e5025224.png";
export const LAB_WORKER = "https://images.unsplash.com/photo-1639772823907-a716be4bdecc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsYWJvcmF0b3J5JTIwbWljcm9zY29wZSUyMGJsdWV8ZW58MHx8fHwxNzc4ODMyODM4fDA&ixlib=rb-4.1.0&q=85";

export const CATEGORIES = [
    "All",
    "Weight Management",
    "Recovery",
    "Cognitive & Wellness",
    "Longevity & Research",
    "Hormonal Support",
    "Skin & Beauty",
    "Blends",
    "Essentials",
];

// Each product has `price` (sale) and `regular_price` (was, crossed out on card).
export const PRODUCTS = [
    // Weight Management
    {
        id: "retatrutide",
        name: "Retatrutide",
        category: "Weight Management",
        dosage: "Multi-strength",
        // default variant for filtering / search / fallback
        price: 119.99,
        regular_price: 149.99,
        short: "Advanced multi-receptor research peptide explored for appetite regulation, metabolic signaling, and weight-management applications. Designed for laboratory research involving energy balance and body composition pathways.",
        image: VIAL("retatrutide-10mg"),
        variants: [
            {
                id: "retatrutide-10mg",
                strength: "10MG",
                dosage: "10MG / vial",
                price: 119.99,
                regular_price: 149.99,
                image: VIAL("retatrutide-10mg"),
            },
            {
                id: "retatrutide-20mg",
                strength: "20MG",
                dosage: "20MG / vial",
                price: 169.99,
                regular_price: 209.99,
                image: VIAL("retatrutide-20mg"),
            },
            {
                id: "retatrutide-30mg",
                strength: "30MG",
                dosage: "30MG / vial",
                price: 199.99,
                regular_price: 249.99,
                image: VIAL("retatrutide"),
            },
            {
                id: "retatrutide-60mg",
                strength: "60MG",
                dosage: "60MG / vial",
                price: 329.99,
                regular_price: 399.99,
                image: VIAL("retatrutide-60mg"),
            },
        ],
    },
    {
        id: "tirzepatide",
        name: "Tirzepatide",
        category: "Weight Management",
        dosage: "Multi-strength",
        price: 109.99,
        regular_price: 139.99,
        short: "Dual-receptor research peptide explored for appetite regulation, metabolic signaling, glucose-response pathways, and weight-management laboratory applications. Commonly studied in research involving energy balance and body composition support.",
        image: VIAL("tirzepatide"),
        variants: [
            {
                id: "tirzepatide-20mg",
                strength: "20MG",
                dosage: "20MG / vial",
                price: 109.99,
                regular_price: 139.99,
                image: VIAL("tirzepatide-20mg"),
            },
            {
                id: "tirzepatide-30mg",
                strength: "30MG",
                dosage: "30MG / vial",
                price: 179.99,
                regular_price: 229.99,
                image: VIAL("tirzepatide"),
            },
        ],
    },
    {
        id: "5-amino-1mq",
        name: "5-Amino-1MQ",
        category: "Weight Management",
        dosage: "Multi-strength",
        price: 69.99,
        regular_price: 94.99,
        short: "Metabolic research compound explored for fat-metabolism signaling, energy utilization, and body-composition laboratory applications. Commonly studied in research involving cellular energy pathways and metabolic support.",
        image: VIAL("5-amino-1mq"),
        variants: [
            {
                id: "5-amino-1mq-5mg",
                strength: "5MG",
                dosage: "5MG / vial",
                price: 69.99,
                regular_price: 94.99,
                image: VIAL("5-amino-1mq"),
            },
            {
                id: "5-amino-1mq-50mg",
                strength: "50MG",
                dosage: "50MG / vial",
                price: 79.99,
                regular_price: 99.99,
                image: VIAL("5-amino-1mq-50mg"),
            },
        ],
    },
    {
        id: "cagrilintide",
        name: "Cagrilintide",
        category: "Weight Management",
        dosage: "5MG / vial",
        price: 79.99,
        regular_price: 99.99,
        short: "Cagrilintide is a long-acting amylin analogue studied in laboratory and clinical research involving amylin-receptor signaling, appetite and satiety pathways, energy intake, metabolic regulation, glucose-related mechanisms, and body-weight regulation.",
        image: VIAL("cagrilintide"),
        fullDescription: true,
    },

    // Recovery
    {
        id: "bpc-157",
        name: "BPC-157",
        category: "Recovery",
        dosage: "Multi-strength",
        price: 69.99,
        regular_price: 89.99,
        short: "Regenerative research peptide explored for recovery support, tissue-repair pathways, and laboratory studies involving muscle, tendon, ligament, connective-tissue, and gastrointestinal research applications.",
        image: VIAL("bpc-157"),
        variants: [
            {
                id: "bpc-157-10mg",
                strength: "10MG",
                dosage: "10MG / vial",
                price: 69.99,
                regular_price: 89.99,
                image: VIAL("bpc-157"),
            },
            {
                id: "bpc-157-20mg",
                strength: "20MG",
                dosage: "20MG / vial",
                price: 109.99,
                regular_price: 139.99,
                image: VIAL("bpc-157-20mg"),
            },
        ],
    },
    {
        id: "tb-500",
        name: "TB-500",
        category: "Recovery",
        dosage: "10MG / vial",
        price: 59.99,
        regular_price: 79.99,
        short: "Advanced recovery research peptide explored for tissue-repair pathways, mobility support, recovery applications, and laboratory studies involving muscle, tendon, ligament, connective-tissue, and inflammation-related research.",
        image: VIAL("tb-500"),
        fullDescription: true,
    },
    {
        id: "ss-31",
        name: "SS-31",
        category: "Recovery",
        dosage: "10MG / vial",
        price: 69.99,
        regular_price: 89.99,
        short: "Mitochondrial research peptide explored for cellular-energy support, recovery pathways, oxidative-stress research, and laboratory studies involving endurance, metabolic function, and cellular performance applications.",
        image: VIAL("ss-31"),
        fullDescription: true,
    },
    {
        id: "kpv",
        name: "KPV",
        category: "Recovery",
        dosage: "10MG / vial",
        price: 59.99,
        regular_price: 79.99,
        short: "KPV is an α-MSH-derived research peptide explored for its potential role in inflammatory response modulation, gastrointestinal health research, immune system support pathways, and laboratory studies involving cellular recovery and tissue repair.",
        image: VIAL("kpv"),
        fullDescription: true,
    },
    {
        id: "dermorphin",
        name: "Dermorphin",
        category: "Recovery",
        dosage: "5MG / vial",
        price: 74.99,
        regular_price: 99.99,
        short: "Heptapeptide for opioid receptor research.",
        image: VIAL("dermorphin"),
    },

    // Cognitive & Wellness
    {
        id: "semax",
        name: "Semax",
        category: "Cognitive & Wellness",
        dosage: "10MG / vial",
        price: 59.99,
        regular_price: 79.99,
        short: "Semax is a synthetic research peptide explored for its potential role in cognitive function, memory support pathways, focus, learning processes, and laboratory studies involving neuroprotection and brain-derived signaling mechanisms.",
        image: VIAL("semax"),
        fullDescription: true,
    },
    {
        id: "selank",
        name: "Selank",
        category: "Cognitive & Wellness",
        dosage: "10MG / vial",
        price: 49.99,
        regular_price: 69.99,
        short: "Selank is a synthetic research peptide studied for its potential role in stress response pathways, mood regulation, cognitive function, mental clarity, and laboratory research involving neurochemical signaling and overall neurological support.",
        image: VIAL("selank"),
        fullDescription: true,
    },
    {
        id: "dsip",
        name: "DSIP",
        category: "Cognitive & Wellness",
        dosage: "Multi-strength",
        // default variant for filtering / search / fallback
        price: 44.99,
        regular_price: 59.99,
        short: "DSIP (Delta Sleep-Inducing Peptide) is a research peptide explored for its potential role in sleep regulation, recovery pathways, stress response, circadian rhythm research, and laboratory studies involving neurological and endocrine function.",
        image: VIAL("dsip"),
        variants: [
            {
                id: "dsip-5mg",
                strength: "5MG",
                dosage: "5MG / vial",
                price: 44.99,
                regular_price: 59.99,
                image: VIAL("dsip"),
            },
            {
                id: "dsip-10mg",
                strength: "10MG",
                dosage: "10MG / vial",
                price: 79.99,
                regular_price: 99.99,
                image: VIAL("dsip-10mg"),
            },
            {
                id: "dsip-15mg",
                strength: "15MG",
                dosage: "15MG / vial",
                price: 109.99,
                regular_price: 139.99,
                image: VIAL("dsip-15mg"),
            },
        ],
    },
    {
        id: "snap-8",
        name: "SNAP-8",
        category: "Cognitive & Wellness",
        dosage: "10MG / vial",
        price: 69.99,
        regular_price: 89.99,
        short: "SNAP-8 is a synthetic research peptide studied for its potential role in neuromuscular signaling pathways, expression line research, skin appearance studies, and laboratory applications involving peptide-based cosmetic and anti-aging research.",
        image: VIAL("snap-8"),
        fullDescription: true,
    },
    {
        id: "pinealon",
        name: "Pinealon",
        category: "Cognitive & Wellness",
        dosage: "10MG / vial",
        price: 59.99,
        regular_price: 79.99,
        short: "Pinealon is a synthetic short peptide studied in laboratory research involving neuronal function, cellular signaling, gene-expression pathways, oxidative-stress responses, neurobiological mechanisms, and age-related changes associated with cellular function and nervous-system biology.",
        image: VIAL("pinealon"),
        fullDescription: true,
    },

    // Longevity & Research
    {
        id: "aicar",
        name: "AICAR",
        category: "Longevity & Research",
        dosage: "50MG / vial",
        price: 74.99,
        regular_price: 94.99,
        short: "AICAR (5-Aminoimidazole-4-carboxamide ribonucleotide) is a research compound studied for its role in AMPK signaling, cellular energy regulation, glucose and lipid metabolism, mitochondrial function, and laboratory research involving metabolic adaptation and energy homeostasis.",
        image: VIAL("aicar"),
        fullDescription: true,
    },
    {
        id: "mots-c",
        name: "MOTS-C",
        category: "Longevity & Research",
        dosage: "Multi-strength",
        // Default variant for filtering / search / fallback
        price: 59.99,
        regular_price: 79.99,
        short: "MOTS-C is a mitochondrial-derived research peptide explored for its potential role in metabolic function, cellular energy production, exercise performance research, healthy aging pathways, and laboratory studies involving mitochondrial health and metabolic regulation.",
        image: VIAL("mots-c"),
        fullDescription: true,
        variants: [
            {
                id: "mots-c",
                strength: "10MG",
                dosage: "10MG / vial",
                price: 59.99,
                regular_price: 79.99,
                image: VIAL("mots-c"),
            },
            {
                id: "mots-c-20mg",
                strength: "20MG",
                dosage: "20MG / vial",
                price: 89.99,
                regular_price: 119.99,
                image: VIAL("mots-c-20mg"),
            },
        ],
    },
    {
        id: "epithalon",
        name: "Epithalon",
        category: "Longevity & Research",
        dosage: "10MG / vial",
        price: 79.99,
        regular_price: 99.99,
        short: "Epithalon is a synthetic tetrapeptide studied in laboratory research involving cellular aging, telomerase activity, telomere biology, circadian and endocrine signaling, oxidative-stress pathways, and mechanisms associated with cellular longevity and age-related biological processes.",
        image: VIAL("epithalon"),
        fullDescription: true,
    },
    {
        id: "glutathione",
        name: "Glutathione",
        category: "Longevity & Research",
        dosage: "1500MG / vial",
        price: 89.99,
        regular_price: 109.99,
        short: "Glutathione is a naturally occurring tripeptide studied extensively for its role in cellular antioxidant defense, redox homeostasis, oxidative-stress regulation, detoxification pathways, cellular signaling, and mechanisms involved in maintaining normal cellular function and protection from reactive species.",
        image: VIAL("glutathione"),
        fullDescription: true,
    },
    {
        id: "ll-37",
        name: "LL-37",
        category: "Longevity & Research",
        dosage: "10MG / vial",
        price: 69.99,
        regular_price: 89.99,
        short: "LL-37 is a human cathelicidin antimicrobial peptide studied in laboratory research involving innate immune defense, antimicrobial activity, inflammatory signaling, host-defense mechanisms, cellular responses to microorganisms, tissue-repair pathways, and interactions between innate and adaptive immune processes.",
        image: VIAL("ll-37"),
        fullDescription: true,
    },
    {
        id: "nad-plus",
        name: "NAD+",
        category: "Longevity & Research",
        dosage: "1000MG / vial",
        price: 139.99,
        regular_price: 179.99,
        short: "NAD+ is a coenzyme research compound explored for its potential role in cellular energy production, mitochondrial function, metabolic health research, healthy aging pathways, and laboratory studies involving cellular repair and oxidative stress response.",
        image: VIAL("nad-plus"),
        fullDescription: true,
    },
    {
        id: "thymosin-alpha-1",
        name: "Thymosin Alpha-1",
        category: "Longevity & Research",
        dosage: "5MG / vial",
        price: 74.99,
        regular_price: 99.99,
        short: "Thymosin Alpha-1 is a research peptide studied for its potential role in immune system function, immune modulation, cellular defense mechanisms, inflammatory response pathways, and laboratory research involving infectious disease, oncology, and overall physiological resilience.",
        image: VIAL("thymosin-alpha-1"),
        fullDescription: true,
    },

    // Hormonal Support
    {
        id: "hcg",
        name: "HCG",
        category: "Hormonal Support",
        dosage: "10000 IU / vial",
        price: 69.99,
        regular_price: 89.99,
        short: "HCG (Human Chorionic Gonadotropin) is a research peptide hormone studied for its potential role in testosterone production pathways, reproductive function, fertility research, hormonal signaling, and laboratory studies involving endocrine system regulation and gonadal function.",
        image: VIAL("hcg"),
        fullDescription: true,
    },
    {
        id: "ipamorelin",
        name: "Ipamorelin",
        category: "Hormonal Support",
        dosage: "10MG / vial",
        price: 54.99,
        regular_price: 69.99,
        short: "Ipamorelin is a research peptide studied for its potential role in growth hormone release pathways, recovery research, body composition studies, and laboratory investigations involving muscle maintenance, metabolic function, and overall physiological performance.",
        image: VIAL("ipamorelin"),
        fullDescription: true,
    },
    {
        id: "hgh-191aa",
        name: "HGH 191AA",
        category: "Hormonal Support",
        dosage: "10IU / vial",
        price: 89.99,
        regular_price: 119.99,
        short: "HGH 191AA (Human Growth Hormone) is a research peptide studied for its potential role in growth hormone pathways, body composition research, metabolic function, cellular regeneration, and laboratory investigations involving physiological performance.",
        image: VIAL("hgh-191aa"),
        fullDescription: true,
    },
    {
        id: "cjc-1295-no-dac",
        name: "CJC-1295 NO DAC",
        category: "Hormonal Support",
        dosage: "10MG / vial",
        price: 59.99,
        regular_price: 79.99,
        short: "CJC-1295 NO DAC is a research peptide studied for its potential role in growth hormone signaling pathways, body composition research, recovery studies, metabolic function, and laboratory investigations involving physiological performance and endocrine regulation.",
        image: VIAL("cjc-1295-no-dac"),
        fullDescription: true,
    },
    {
        id: "ghrp-2",
        name: "GHRP-2",
        category: "Hormonal Support",
        dosage: "10MG / vial",
        price: 69.99,
        regular_price: 89.99,
        short: "GHRP-2 is a synthetic growth hormone secretagogue studied in laboratory research involving ghrelin-receptor signaling, growth hormone release, endocrine signaling, pituitary pathways, metabolic regulation, and mechanisms associated with the growth hormone and IGF-1 axis.",
        image: VIAL("ghrp-2"),
        fullDescription: true,
    },
    {
        id: "ghrp-6",
        name: "GHRP-6",
        category: "Hormonal Support",
        dosage: "10MG / vial",
        price: 69.99,
        regular_price: 89.99,
        short: "GHRP-6 is a synthetic growth hormone secretagogue studied in laboratory research involving ghrelin-receptor activity, growth hormone release, appetite-related signaling, endocrine pathways, energy metabolism, and mechanisms associated with the growth hormone and IGF-1 axis.",
        image: VIAL("ghrp-6"),
        fullDescription: true,
    },
    {
        id: "igf-1-lr3",
        name: "IGF-1 LR3",
        category: "Hormonal Support",
        dosage: "1MG / vial",
        price: 89.99,
        regular_price: 109.99,
        short: "IGF-1 LR3 is a modified analogue of insulin-like growth factor-1 studied in laboratory research involving IGF-1 receptor signaling, cellular growth and differentiation, protein-synthesis pathways, glucose metabolism, tissue-development mechanisms, and signaling associated with the IGF axis.",
        image: VIAL("igf-1-lr3"),
        fullDescription: true,
    },
    {
        id: "mk-677",
        name: "MK-677 (Ibutamoren)",
        category: "Hormonal Support",
        dosage: "10MG / vial",
        price: 59.99,
        regular_price: 79.99,
        short: "MK-677, also known as Ibutamoren, is a non-peptide research compound studied for its activity at the ghrelin receptor and its effects on growth-hormone and IGF-1 signaling, appetite-related pathways, metabolic regulation, body-composition mechanisms, and endocrine signaling.",
        image: VIAL("mk-677"),
        fullDescription: true,
    },
    {
        id: "tesamorelin",
        name: "Tesamorelin",
        category: "Hormonal Support",
        dosage: "10MG / vial",
        price: 119.99,
        regular_price: 149.99,
        short: "Tesamorelin is a synthetic growth hormone-releasing hormone (GHRH) analogue studied for its effects on growth hormone and IGF-1 signaling, visceral adipose tissue, abdominal fat distribution, lipid metabolism, body-composition pathways, and endocrine mechanisms involved in metabolic regulation.",
        image: VIAL("tesamorelin"),
        fullDescription: true,
    },

    // Skin & Beauty
    {
        id: "ahk-cu",
        name: "AHK-Cu",
        category: "Skin & Beauty",
        dosage: "100MG / vial",
        price: 84.99,
        regular_price: 109.99,
        short: "AHK-Cu is a copper-binding tripeptide studied in laboratory research involving skin biology, cellular signaling, extracellular matrix activity, collagen-related pathways, tissue remodeling, and hair-follicle biology.",
        image: VIAL("ahk-cu"),
        fullDescription: true,
    },
    {
        id: "ghk-cu",
        name: "GHK-Cu",
        category: "Skin & Beauty",
        dosage: "100MG / vial",
        price: 109.99,
        regular_price: 139.99,
        short: "GHK-Cu (Copper Peptide) is a research peptide studied for its potential role in skin health research, tissue regeneration pathways, cellular repair mechanisms, hair follicle studies, and laboratory investigations involving healthy aging and cosmetic science.",
        image: VIAL("ghk-cu"),
        fullDescription: true,
    },
    {
        id: "melanotan-1",
        name: "Melanotan-1",
        category: "Skin & Beauty",
        dosage: "10MG / vial",
        price: 49.99,
        regular_price: 69.99,
        short: "Melanotan-1 is a research peptide studied for its potential role in melanocortin receptor pathways, pigmentation research, skin response studies, UV exposure models, and laboratory investigations involving melanin production and tanning-related research.",
        image: VIAL("melanotan-1"),
        fullDescription: true,
    },

    // Blends
    {
        id: "glow-blend",
        name: "Glow Blend",
        category: "Blends",
        dosage: "GHK-Cu 50MG + BPC-157 10MG + TB-500 10MG",
        price: 179.99,
        regular_price: 229.99,
        short: "Glow is a research peptide blend containing GHK-Cu, TB-500, and BPC-157, studied for its potential role in skin health research, tissue regeneration pathways, cellular repair mechanisms, recovery studies, and laboratory investigations involving cosmetic science and healthy aging.",
        image: VIAL("glow-blend"),
        fullDescription: true,
    },

    // Essentials (support items only — no peptides)
    {
        id: "bac-water-3ml",
        name: "Bacteriostatic Water",
        category: "Essentials",
        dosage: "Multi-size",
        // Default variant for filtering / search / fallback
        price: 9.99,
        regular_price: 14.99,
        short: "Bacteriostatic Water is a sterile water solution containing 0.9% benzyl alcohol, commonly utilized in laboratory settings for research preparation, peptide reconstitution applications, and controlled storage studies.",
        image: VIAL("bac-water-3ml"),
        fullDescription: true,
        variantLabel: "Select Size",
        variants: [
            {
                id: "bac-water-3ml",
                strength: "3ML",
                dosage: "3ML / vial",
                price: 9.99,
                regular_price: 14.99,
                image: VIAL("bac-water-3ml"),
            },
            {
                id: "bac-water-10ml",
                strength: "10ML",
                dosage: "10ML / vial",
                price: 14.99,
                regular_price: 19.99,
                image: VIAL("bac-water-10ml"),
            },
        ],
    },
    {
        id: "syringes",
        name: "Insulin Syringes",
        category: "Essentials",
        dosage: "10 pack · 1ML · 31G",
        price: 9.99,
        regular_price: 14.99,
        short: "Insulin syringes are sterile precision measurement tools commonly used in laboratory settings for accurate liquid handling, research preparation, and controlled measurement applications involving small-volume solutions.",
        image: VIAL("syringes"),
        fullDescription: true,
    },
];

export const FAQS = [
    {
        q: "Are your products intended for human consumption?",
        a: "No. All products offered by Quantum Genesis Labs are intended strictly for laboratory and research purposes only. Products are not intended for human or veterinary use, diagnosis, or therapeutic applications.",
    },
    {
        q: "What type of research products do you offer?",
        a: "Quantum Genesis Labs provides premium research peptides and laboratory compounds sourced for purity, consistency, and professional research applications.",
    },
    {
        q: "How should products be stored?",
        a: "Products should be stored in a cool, dry environment away from direct light and moisture. Proper laboratory handling, storage, and reconstitution practices are recommended to maintain product integrity.",
    },
    {
        q: "How are your products labeled?",
        a: "All research products are professionally labeled with compound identification, concentration details, and research-use information for accurate handling and organization.",
    },
    {
        q: "Do you accept returns?",
        a: "Due to the nature of laboratory research materials, all sales are considered final. If there is an issue with your order, please contact our support team for assistance.",
    },
    {
        q: "How can I contact Quantum Genesis Labs?",
        a: "Most research inquiries receive a quick response through Telegram or email.",
    },
];
